// React
import React, { useState } from "react";
// Tiptap
import FontFamily from "@tiptap/extension-font-family";
import TextStyle from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import FontFamilyMenu from "./FontFamilyMenu";
import StylesMenu from "./StylesMenu";
// Tiptap Collab
import Collaboration from "@tiptap/extension-collaboration";
import CollaborationCursor from "@tiptap/extension-collaboration-cursor";
import { WebrtcProvider } from "y-webrtc";
import * as Y from "yjs";
// React icons
import {
  FaBold,
  FaItalic,
  FaListOl,
  FaListUl,
  FaQuoteLeft,
  FaRedo,
  FaStrikethrough,
  FaUnderline,
  FaUndo,
} from "react-icons/fa";
// css
import "./styles.css";

// A new Y document
const ydoc = new Y.Doc();
// Registered with a WebRTC provider
const provider = new WebrtcProvider("SUSUdocument", ydoc);

// Head Menu
const MenuBar = ({ editor }) => {
  // Render with editor
  if (!editor) return null;
  return (
    <div className="MenuBar">
      <div className="Controls">
        <div>
          <button className="list">
            {/* Text Styles Menu: Headings, etc. */}
            <StylesMenu editor={editor} />
          </button>
          <button className="list">
            {/* Font Styles Menu: Arial, etc. */}
            <FontFamilyMenu editor={editor} />
          </button>
        </div>
        <div>
          <button
            onClick={() => editor.chain().focus().toggleBold().run()}
            className={editor.isActive("bold") ? "is-active" : ""}
          >
            <FaBold />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleItalic().run()}
            className={editor.isActive("italic") ? "is-active" : ""}
          >
            <FaItalic />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            className={editor.isActive("underline") ? "is-active" : ""}
          >
            <FaUnderline />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleStrike().run()}
            className={editor.isActive("strike") ? "is-active" : ""}
          >
            <FaStrikethrough />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            className={editor.isActive("bulletList") ? "is-active" : ""}
          >
            <FaListUl />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            className={editor.isActive("orderedList") ? "is-active" : ""}
          >
            <FaListOl />
          </button>
          <button
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
            className={editor.isActive("blockquote") ? "is-active" : ""}
          >
            <FaQuoteLeft />
          </button>
        </div>
      </div>
      <div>
        <button onClick={() => editor.chain().focus().undo().run()}>
          <FaUndo />
        </button>
        <button onClick={() => editor.chain().focus().redo().run()}>
          <FaRedo />
        </button>
      </div>
    </div>
  );
};

// Editor
const Tiptap = ({ name, team, content, setContent }) => {
  const editor = useEditor(
    {
      extensions: [
        // Basic Framework
        StarterKit.configure({
          history: false,
        }),
        // Underline Style
        Underline,
        // Text Styling
        TextStyle,
        // Choose Fonts
        FontFamily.configure({
          types: ["textStyle"],
          default: "Arial",
        }),
        // Collaberation Connection
        Collaboration.configure({
          document: ydoc,
        }),
        // Curour Name when Collab
        CollaborationCursor.configure({
          provider: provider,
          user: {
            name: name,
            color: "#f783ac",
          },
        }),
      ],
      // Initialize Starting Content
      content: content,
      // Set starting font to Arial
      onCreate: ({ editor }) => {
        editor.chain().focus().setFontFamily("Arial").run();
      },
      // Keep record and update render
      // onUpdate: ({ editor }) => {
      //   const record = editor.getHTML();
      //   // editor.commands.setContent(record);
      //   setContent(record);
      // },
      watch: {
        // Handles external model changes.
        value(newVal) {
          // convert whitespace into \u00a0 -> &nbsp;
          let record = newVal.replace("/s/g", "\u00a0");
          editor.commands.setContent(record);
          setContent(record);
        },
      },
    },
    [content]
  );

  return (
    <div className="TextEditor">
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
      {/*<div dangerouslySetInnerHTML={{ __html: content }}></div>*/}
    </div>
  );
};

export default Tiptap;
